var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":"/static/base/img/no-input.svg"}}),_c('p',[_vm._v("موردی یافت نشد")])])])
}]

export { render, staticRenderFns }